<app-modal [dismissible]="false">
    <ng-container modal-header>
        <h5 class="modal-title">
            <app-tooltip *ngIf="transport && transport.hasPriority"
                         type="info" [tooltipPosition]="'left'"
                         record="{{(transport.priorityReason === 'issue'?
                                   'milkrun.transportation-requests.transport-details.issue':
                                   'milkrun.transportation-requests.transport-details.maintenance') | translate}}">
            </app-tooltip>
            {{ transport.name }}
        </h5>
    </ng-container>
    <div class="body" modal-body>
        <div class="info">
            <app-display-label label="{{ 'milkrun.transportation-requests.table.columns.location' | translate }}"
                               [value]="transportLocation(transport)">
            </app-display-label>
            <app-display-label label="{{ 'milkrun.transportation-requests.table.columns.destination' | translate }}"
                               [value]="transportDestination(transport)">
            </app-display-label>
            <app-display-label label="{{ 'milkrun.transportation-requests.table.columns.createdDate' | translate }}"
                               [value]="createdDate">
            </app-display-label>
            <app-display-label label="{{ 'milkrun.transportation-requests.table.columns.createdBy' | translate }}"
                               [value]="transport?.createdBy">
            </app-display-label>
            <app-display-label *ngIf="reason"
                               [label]="infoLabel"
                               [value]="reason">
            </app-display-label>
        </div>
        <div class="tools">
            <app-tool-scan-tree
                labelText="{{'milkrun.transportation-requests.transport-details.tools'| translate}}"
                [items]="tools"
                [loading]="isLoading">
            </app-tool-scan-tree>
        </div>
    </div>
    <div class="footer"  modal-footer>
        <app-button type="simple"
                    (click)="onCancel()"
                    [disabled]="isConfirmationInProgress"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
        <app-button *ngIf="transport && transport.load"
                    type="primary"
                    class="btn btn-primary" (click)="onLoad()">
            {{ 'generic.buttons.load' | translate }}
        </app-button>
        <app-button *ngIf="transport && !transport.load"
                    type="warning"
                    (click)="onUnload()">
            {{ 'generic.buttons.unload' | translate }}
        </app-button>
    </div>
</app-modal>
